import Vue from 'vue';
import VueI18n from 'vue-i18n';
import qcvueZH from '@tencent/qcvue2/lib/locale/lang/zh-CN';
import qcvueEN from '@tencent/qcvue2/lib/locale/lang/en';

import { store } from '@/scripts/store';

import zh from './zh';
import en from './en';

Vue.use(VueI18n);

const locale = store.localeLanguage || 'zh';

const i18n = new VueI18n({
  locale, // 语言标识
  messages: {
    zh: { ...zh, ...qcvueZH },
    en: { ...en, ...qcvueEN },
  },
});

i18n.err = (path, opt) => {
  opt = opt || '';
  let msg = '';
  const { error } = opt;
  if (error) {
    msg = error.Message || error.Code;
  } else {
    msg = opt.message || opt.msg || opt.Message || opt.error || opt;
  }
  if (typeof msg === 'object') msg = '';
  const text = i18n.te(path) ? i18n.t(path) : '';
  const sep = text && msg ? ', ' : '';
  let result = text + sep + msg; // 显示文字提示以及错误的具体内容
  if (!result) result = i18n.t(path); // 如果没找到文案，也没传入 opt，显示文案路径本身
  return result;
};

window.lang = i18n;

export default i18n;
